<script setup lang="ts">
import HomeView from './views/HomeView.vue';
import { captchaMessagesListener } from './services/handleCaptchaRequest';
import { WebsiteLogger } from './utils/logWebsite';
import { usePoshmarkUser } from './stores/PoshmarkUserStore';


const poshmarkUser = usePoshmarkUser()
const initEventsListener = (event: any) => {
    if (!event.data && !event.data.message) return

    if (event.data.message == 'update-poshmark-user') {
        poshmarkUser.setUser({ username: event.data.username, userID: event.data.userID })
    }
}

window.addEventListener('message', captchaMessagesListener)
window.addEventListener('message', initEventsListener)
WebsiteLogger.initExtensionListener();
</script>

<template>
    <HomeView />
</template>
